const stats = [
  { value: '200+', label: 'Steinarten weltweit' },
  { value: '25+', label: 'Jahre Erfahrung' },
  { value: '5.000+', label: 'Zufriedene Kunden' },
  { value: '12', label: 'Länder & Ursprünge' },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-white py-32 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Tag */}
        <div className="flex justify-center mb-10">
          <span className="px-4 py-1 rounded-full border border-stone-300 text-stone-500 text-xs tracking-widest uppercase">
            Über uns
          </span>
        </div>

        {/* Headline */}
        <h2
          className="text-center font-light text-stone-900 leading-tight mb-6 max-w-4xl mx-auto"
          style={{ fontSize: 'clamp(2rem, 4vw, 3.5rem)', fontFamily: "'Playfair Display', serif" }}
        >
          Wir sind Ihr Partner für <em className="not-italic text-stone-400">Ziersteine</em> aus aller Welt.
        </h2>

        <p className="text-center text-stone-500 text-base leading-relaxed max-w-2xl mx-auto mb-20">
          Entdecken Sie die Vielfältigkeit von Natursteinen für Ihren Vorgarten sowie Ihre Wohn- oder Parkanlage. Hinter jedem unserer Steine verbirgt sich eine Geschichte, die wir mit Ihnen teilen wollen.
        </p>

        {/* Two Column */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
          {/* Left: Image */}
          <div className="relative">
            <div className="w-full h-96 rounded-2xl overflow-hidden">
              <img
                src="https://ziersteine.de/wp-content/uploads/2019/02/showstone.png"
                alt="Naturstein Showstone"
                className="w-full h-full object-contain object-center bg-stone-50"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-stone-900 text-white rounded-2xl px-6 py-4 shadow-lg">
              <p className="text-2xl font-semibold">25+</p>
              <p className="text-xs text-stone-300 mt-1">Jahre Expertise</p>
            </div>
          </div>

          {/* Right: Text */}
          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-semibold text-stone-900 mb-3">Eine Geschichte hinter jedem Stein</h3>
              <p className="text-stone-500 text-sm leading-relaxed">
                Rosenquarze – geschürft aus den tiefsten Mienen Südafrikas, Basalte entstanden bei Vulkanausbrüchen in Island oder Muscheln aus den entferntesten Ozeanen der Erde. Unsere Materialien sind alle natürlichen Ursprungs und nicht nur ein wunderschöner Blickfang in Ihrem Garten, sondern mit Sicherheit etwas ganz Besonderes in Ihrer Nachbarschaft.
              </p>
            </div>
            <div className="h-px bg-stone-100" />
            <div>
              <h3 className="text-xl font-semibold text-stone-900 mb-3">Zeitersparnis durch Ziersteine</h3>
              <p className="text-stone-500 text-sm leading-relaxed">
                Ziersteine verhindern den Wuchs von Unkräutern und müssen nicht gekürzt werden. Peppen Sie Ihren Vorgarten auf und gewinnen Sie Ihre Freizeit zurück – mehr Zeit, die Sie mit Ihren Lieben oder Ihrem Hobby verbringen können.
              </p>
            </div>
            <div className="h-px bg-stone-100" />
            <div>
              <h3 className="text-xl font-semibold text-stone-900 mb-3">Individuell auf Sie abgestimmt</h3>
              <p className="text-stone-500 text-sm leading-relaxed">
                Gern erstellen wir Ihnen ein individuelles Angebot, genau nach Ihren Wünschen. Unsere riesige Auswahl an verschiedensten Natursteinen — von Basalt über Granite, Marmore und Quarze bis Sodalith — in vielen verschiedenen Größen spricht für sich.
              </p>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="bg-stone-50 rounded-2xl p-8 text-center">
              <p className="text-3xl font-semibold text-stone-900 mb-1">{stat.value}</p>
              <p className="text-xs text-stone-500 tracking-wide uppercase">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
